import {
	RightPanelAction,
	SelectedDocument,
} from '@dealstack/frontend/app/pages/Project/DocumentLibrary/types';
import { TreeItemsWithMeta } from '@dealstack/frontend/app/pages/Project/DocumentLibrary/utils';
import { TableOperations } from '@dealstack/frontend/shared/components/Table/MantineTable/useMantineTableWithPaginationFilteringSorting';
import { RefObject } from 'react';
import { EditDocument } from './EditDocument';
import { ArchiveDocument } from './ArchiveDocument';
import { BulkClassifier } from './BulkClassifier';
import { ClassificationGroupType } from '@dealstack/shared/lib/backendClient';
import { EditPersonsToDocuments } from './EditPersonsToDocuments';

interface Props {
	selectedDocument: SelectedDocument | undefined;
	selectedTreeItem: TreeItemsWithMeta | undefined;
	documentsTableDataOperationsRef: RefObject<
		TableOperations<{
			relatedToIds: string[];
			updatedAt: { from: string; to: string };
			mipIds: string[];
		}>
	>;
	rightPanelAction: RightPanelAction;
	areAllRowsSelected: boolean;
	selectedDocumentIds: string[];
	treeItems: TreeItemsWithMeta[];
	isTreeItemsMenuLoading: boolean;
	classificationId: string | undefined;
	classificationGroup: ClassificationGroupType | undefined;
	setRightPanelAction: (action: RightPanelAction) => void;
	dealId: string;
}

export const RightPanel = ({
	selectedDocument,
	selectedTreeItem,
	documentsTableDataOperationsRef,
	rightPanelAction,
	areAllRowsSelected,
	selectedDocumentIds,
	treeItems,
	isTreeItemsMenuLoading,
	classificationId,
	classificationGroup,
	setRightPanelAction,
	dealId,
}: Props) => {
	switch (rightPanelAction) {
		case RightPanelAction.NONE:
			return null;
		case RightPanelAction.EDIT_DOCUMENT:
			if (!selectedDocument) {
				return null;
			}

			return (
				<EditDocument
					isRightSidePanelOpen={true}
					setRightPanelAction={setRightPanelAction}
					dealId={dealId}
					selectedDocument={selectedDocument}
				/>
			);

		case RightPanelAction.ARCHIVE_DOCUMENT:
			if (!selectedDocument) {
				return null;
			}

			return (
				<ArchiveDocument
					dealId={dealId}
					setRightPanelAction={setRightPanelAction}
					selectedDocumentId={selectedDocument.documentId}
				/>
			);

		case RightPanelAction.BULK_CLASSIFY:
			return (
				<BulkClassifier
					dealId={dealId}
					setRightPanelAction={setRightPanelAction}
					selectedDocumentIds={selectedDocumentIds}
					areAllRowsSelected={areAllRowsSelected}
					selectedTreeItem={selectedTreeItem}
					treeItems={treeItems}
					isTreeItemsMenuLoading={isTreeItemsMenuLoading}
					documentsTableDataOperationsRef={documentsTableDataOperationsRef}
				/>
			);

		case RightPanelAction.BULK_ADD_PERSONS:
			return (
				<EditPersonsToDocuments
					dealId={dealId}
					setRightPanelAction={setRightPanelAction}
					allDocumentsSelected={areAllRowsSelected}
					documentIds={selectedDocumentIds}
					documentsTableDataOperationsRef={documentsTableDataOperationsRef}
					classificationId={classificationId}
					classificationGroup={classificationGroup}
				/>
			);

		default:
			return null;
	}
};
